import Header from "components/Common/Header/Header";
import OxygenSaturationBody from "components/PatientManagement/Vital/OxygenSaturation/OxygenSaturationBody";
import React, { useEffect } from "react";

const OxygenSaturation = () => {
  useEffect(() => {
    document.title = "Vitals | Oxygen Saturation";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <OxygenSaturationBody />
    </main>
  );
};

export default OxygenSaturation;
